import { Controller } from "@hotwired/stimulus";

// Generic "checking this checkbox reveals a section" behavior -- e.g. the
// package search field's "Avancerad hotellsökning" checkbox revealing its
// own check-in/check-out date pickers.
export default class extends Controller {
  static targets = ["checkbox", "panel"];

  connect() {
    this.sync();
  }

  sync() {
    this.panelTarget.classList.toggle("hidden", !this.checkboxTarget.checked);
  }
}
